import styled from 'styled-components';
const DropdownList = styled.div`
  top: ${props => `${props.top || 0}px`};
  right: ${props => `${props.right || 0}px`};
  z-index: 9;
`;
export default DropdownList;